import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollToTopOnRouteUpdate from '@//ui/_lib/ScrollToTopOnRouteUpdate';
import generateRoutes from '@/ui/_lib/generateRoutes';
import appRoutes from '@/routes';
import TextLogo from '@/assets/image/logo-text.png';
import useAuth from '@/hooks/useAuth';
import { useUser } from '@/contexts/UserContext/UserContext';
import './assets/css/tailwind.css';
import { Toaster } from '@/ui/_lib/Toast/Toaster';
import { OfflineBanner } from './pwa/useOffline';
import { InstallBanner } from './pwa/useInstallPrompt';
import { setAuth0TokenGetter } from './api/config';
import LogoutButton from '@/ui/components/LogoutButton';

// Auth0 Token Setup Component
function Auth0TokenSetup({ children }: { children: React.ReactNode }) {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  useUser();

  useEffect(() => {
    if (isAuthenticated) {
      setAuth0TokenGetter(async () => {
        try {
          return await getAccessTokenSilently();
        } catch (error) {

          return null;
        }
      });
    }
  }, [isAuthenticated, getAccessTokenSilently]);

  return <>{children}</>;
}

export default function App() {
  const { isAuthenticated } = useAuth0();
  const location = useLocation();
  useAuth();
  
  // Only show logout button on profile tab
  const showLogoutButton = isAuthenticated && location.pathname !== '/' && location.search.includes('profile');

  return (
    <>
      <Auth0TokenSetup>
        <ScrollToTopOnRouteUpdate />
        <Toaster />
        <OfflineBanner />
        <InstallBanner />
        
        {showLogoutButton && (
          <div className="absolute top-4 right-4 z-50">
            <LogoutButton variant="primary" className="px-4 py-2 text-sm" />
          </div>
        )}

        <div
          id="app_playground"
          className="flex h-[100svh] w-screen items-center justify-center bg-black pt-[calc(env(safe-area-inset-top)_/_2)]"
        >
          <div className="absolute left-1/2 top-1/2 flex h-[100svh] w-screen -translate-x-1/2 -translate-y-1/2 select-none items-center justify-center  object-fill p-4 opacity-15">
            <img src={TextLogo} alt="logo" className="w-full" />
          </div>
          <div className="z-20 flex h-[100lvh] w-full items-center justify-center overflow-x-hidden bg-[#F8F8FF] md:bg-transparent">
            {generateRoutes({ routes: appRoutes })}
          </div>
        </div>
      </Auth0TokenSetup>
    </>
  );
}